module.exports = __webpack_public_path__ + "static/img-main-413f8ea05fa9df7802ded80387802242.jpg";